import classNames from 'classnames';
import React, { useEffect } from 'react';

// REDUX & MANAGERS
import { getDeviceInfo, getGlobalStyles, getInGameHistoryMode } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

//PANELS
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import {
    BottomSection,
    CornerPanel,
    DebugTools,
    FreeSpinBar,
    GameNamePanel,
    GamePlayPanel,
    InGameHistoryPage,
    InGameHistoryPanel,
    MaintananceBar,
    MenuPages,
    PopupMessage,
    PopupPanel,
    StatusHorizontal,
    StatusPortrait
} from '@Modules/index';

// TYPES

const MainUI: React.FC<{}> = ({}) => {
    const device = useAppSelector(getDeviceInfo);
    const globalStyles = useAppSelector(getGlobalStyles);
    const inGameHistoryMode = useAppSelector(getInGameHistoryMode);

    const mainUIClasses = classNames(
        styles.main_ui_container,
        globalStyles.orientation,
        globalStyles.handMode,
        globalStyles.device,
        globalStyles.isTablet,
        globalStyles.screenSize
    );

    useEffect(() => {}, [device, inGameHistoryMode]);

    return (
        <div className={mainUIClasses}>
            <div className={styles.main_ui_elements} style={device.windowOrientationPortrait ? { height: `${device.uiMaxCoverage}dvh` } : {}}>
                <div className={styles.main_ui_overlayitems}>
                    {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).debugTools?.active && <DebugTools />}
                    {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).gameNamePanel && <GameNamePanel />}
                    {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).inGameHistory && inGameHistoryMode && <InGameHistoryPanel />}
                    <InGameHistoryPage />
                    <CornerPanel />
                    <PopupPanel />
                    <MenuPages />
                    <PopupMessage />
                    <FreeSpinBar />
                </div>

                <div className={styles.main_ui_gameplaypanel}>
                    <GamePlayPanel />
                </div>

                {device.windowOrientationHorizontal && (
                    <>
                        <div className={styles.main_ui_statushorizontal}>
                            <StatusHorizontal />
                        </div>
                    </>
                )}

                {device.windowOrientationPortrait && (
                    <>
                        <div className={styles.main_ui_status}>
                            <StatusPortrait />
                        </div>
                        <div className={styles.main_ui_maitanancebar}>
                            <MaintananceBar />
                        </div>
                        <div className={styles.main_ui_bottomsection}>
                            <BottomSection />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default MainUI;
